export enum SearchStatusEnum {
    initial = "initial",
    searching = "searching",
    loadingMore = "loadingMore",
    doneWithNoResults = "doneWithNoResults",
    doneWithResults = "doneWithResults",
    doneWithSuggestions = "doneWithSuggestions",
    doneWithNoResultsFilters = 'doneWithNoResultsFilters',
    error = "error"
}
